import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { buildLoginUrlWithRedirect } from '@/config/ipeRoutes';
import { getFundingToken } from '@/utils/api';
import { useIpeAuth } from '@/context/IpeAuthContext';

/**
 * 工作台路由守卫：未登录重定向到登录页（带 redirect 回跳），不渲染业务页面。
 * 有 session 缓存时跳过全屏阻塞，后台静默校验。
 * 有 token 但尚未完成校验时保持「验证中」，避免新标签冷启动 / 瞬时 getMe 失败误踢登录。
 */
export default function IpeRequireAuth() {
  const { isAuthenticated, bootstrapping, sessionVerified, refreshUser } = useIpeAuth();
  const location = useLocation();
  const hasToken = Boolean(getFundingToken());

  useEffect(() => {
    if (!hasToken || sessionVerified || bootstrapping) return undefined;
    // bootstrap 已结束但仍未 verified（多为瞬时网络失败）：主动重试一次
    const timer = window.setTimeout(() => {
      void refreshUser?.();
    }, 400);
    return () => window.clearTimeout(timer);
  }, [bootstrapping, hasToken, refreshUser, sessionVerified]);

  if (!hasToken) {
    return <Navigate to={buildLoginUrlWithRedirect(location)} replace />;
  }

  if (!isAuthenticated || !sessionVerified) {
    return (
      <div className="ipe-route-loading ipe-route-loading--auth" role="status" aria-live="polite">
        <div className="ipe-route-loading__bar" aria-hidden="true" />
        <p>正在验证登录状态…</p>
      </div>
    );
  }

  return <Outlet />;
}
